import { IsAuthenticatedGuard } from '@ip6m/server/auth';
import { Body, Controller, Delete, Get, Logger, Param, Post, UseGuards } from '@nestjs/common';
import { ApiBody, ApiInternalServerErrorResponse, ApiNotFoundResponse, ApiOkResponse, ApiOperation, ApiParam, ApiTags, SwaggerModule } from '@nestjs/swagger';
import { CustomerDBStatus, CustomersBySerial } from '@ip6m/types';
import { ServiceEntity } from '../../../database/models/service.entity';
import { DatabaseService } from '../../../database/services/database/database.service';
import { CustomerService } from '../../../database/services/customer/customer.service';
import { ServiceService } from '../../../database/services/service/service.service';
import { LocationService } from '../../../database/services/location/location.service';
import { AddressEntity } from '../../../database/models/address.entity';
import { GpsCoordinatesEntity } from '../../../database/models/gpscoordinates.entity';
import { CityEntity } from '../../../database/models/city.entity';
import { StreetEntity } from '../../../database/models/street.entity';



@ApiTags('location')
@Controller('/v1/location')
export class LocationController {

    constructor(private database:DatabaseService,
                private locationService:LocationService,
               ) {}



    @ApiOperation({ summary: 'Get cities'})
    @Get('cities')
    getCities(): object {
       
      return this.locationService.getCities()
    }
    
    @ApiOperation({ summary: 'Get streets'})
    @Get('streets/city/:cityId')
    getStreets(@Param()params): object {
        
      return this.locationService.getStreets(params.cityId)
    }

    @ApiOperation({ summary: 'Get street by name'})
    @Get('streets/name/:name')
    getStreetByName(@Param()params): object {
        
      return this.locationService.getStreetByName(params.name)
    }


    @ApiOperation({ summary: 'Create new street'})
    @Post('streets')
    newStreet(@Body()params): object {
      return this.locationService.newStreet(params)
    }
      /* 
    @ApiOperation({ summary: 'Create new city'})
    @Post('cities')
    newCity(@Body()params): object {
        
      return this.locationService.newCity(params)
    }

    @ApiOperation({ summary: 'Delete city'})
    @Delete('cities/:id')
    deleteCity(@Param()params): object {
        
      return this.locationService.deleteCity(params.id)
    }


  

    @ApiOperation({ summary: 'Delete street'})
    @Delete('streets/:id')
    deleteStreet(@Param()params): object {
        
      return this.locationService.deleteStreet(params.id)
    }*/


    


}
